// extracted by css-extract-rspack-plugin
export default {"header":"aLnUNCVBrA4qpmCb"};